<template>
  <div>
    <excise-transactions listObject="wine" :objectId="wineId"
                          :back="[{text:'Wine',to:{name:'Wine'}}]"
                          :contents="false" vessel :exciseTypes="excise.wineExciseTypes(true)"/>
  </div>
</template>

<script>
import ExciseTransactions from '@/components/ExciseTransactions'
import excise from '@/plugins/excise'

export default {
  name: 'WineTransactions',
  components: {ExciseTransactions},
  props: {
    wineId: {type:String, required:true}
  },
  data() {
    return {
      excise
    }
  }
}
</script>